import PropTypes from 'prop-types';
import { Link as RouterLink, useParams } from 'react-router-dom';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material
import { useTheme } from '@mui/material/styles';
import { Box, Card, Link, Typography, Stack, Grid, Container } from '@mui/material';
import Page from '../../../components/Page';
import { styled } from '@mui/material/styles';
// utils
import { fCurrency } from '../../../utils/formatNumber';
// components
import Label from '../../../components/Label';
import { ColorPreview } from '../../../components/color-utils';
import LoadingScreen from 'react-loading-screen';
import { useDispatch } from 'react-redux';

import UserService from '../../../services/user_service'

import {
    AppCurrentVisits,
    AppWidgetSummary,
    AppCurrentSubject,
    AppConversionRates,
} from '../../../sections/@dashboard/app';
import UserApps from './UserApps';
import UserActions from './UserActions';
import CardInfo from '../common/CardInfo';
import { Visible } from '../../../layouts/Visible'

// ----------------------------------------------------------------------

// const ProductImgStyle = styled('img')({
//     top: 0,
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover',
//     position: 'absolute',
// });

export default function UserPage() {
    const params = useParams();

    const { user_id } = params.user_id;
    const [isLoading, setIsLoading] = useState(true);

    const theme = useTheme();
    const [userObj, setUser] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    dispatch({ type: 'USER', payload: { 'user': params.user_id } })

    function loadUser() {
        UserService.getUserInfo(params.user_id)
            .then((response) => response.data)
            .then((data) => setUser(data))
            .then((data) => setIsLoading(false))
            .catch((error) => console.log(error));
    }

    useEffect(() => {
        return () => {
            dispatch({ type: '', payload: { 'user': params.user_id } })
        }
    }, [])

    useEffect(() => {
        if (isLoading) {
            loadUser();
        }
    }, []);


    if (isLoading) {
        return (
            <Visible roles={["admin"]}>
                <Page title="App">
                    <LoadingScreen
                        loading={true}
                        bgColor="rgba(255,255,255,0.8)"
                        spinnerColor="#9ee5f8"
                        textColor="#676767"
                        logoSrc=""
                        text=""
                    >
                        {" "}
                    </LoadingScreen>
                </Page>
            </Visible>
        )
    } else {
        return (
            <Visible roles={["admin"]}>
                <Page title={userObj.first_name}>
                    <Container maxWidth="xl">
                        <Typography variant="h4" sx={{ mb: 5 }}>
                            {userObj.first_name}
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={3}>
                                <AppWidgetSummary title="Apps count" total={userObj.apps_count} icon={'ant-design:android-filled'} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>

                                <CardInfo title="Subscription status" subheader={userObj.subscription} icon={'ant-design:android-filled'} />
                            </Grid>

                            <Grid item xs={12} md={6} lg={4}>
                                <UserApps
                                    title="Apps"
                                    app_id={params.user_id}
                                />
                            </Grid>

                            {/* <Grid item xs={12} md={6} lg={8}>
                            <AppConversionRates
                                title="Conversion Rates"
                                subheader="(+43%) than last year"
                                chartData={[
                                    { label: 'Italy', value: 400 },
                                    { label: 'Japan', value: 430 },
                                    { label: 'China', value: 448 },
                                    { label: 'Canada', value: 470 },
                                    { label: 'France', value: 540 },
                                    { label: 'Germany', value: 580 },
                                    { label: 'South Korea', value: 690 },
                                    { label: 'Netherlands', value: 1100 },
                                    { label: 'United States', value: 1200 },
                                    { label: 'United Kingdom', value: 1380 },
                                ]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6} lg={4}>
                            <AppCurrentSubject
                                title="Current Subject"
                                chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
                                chartData={[
                                    { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                                    { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                                    { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
                                ]}
                                chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
                            />
                        </Grid> */}

                            <Grid item xs={12} md={6} lg={4}>
                                <UserActions
                                    title="User actions"
                                    app_id={params.user_id}
                                />
                            </Grid>

                        </Grid>
                    </Container>
                </Page>
            </Visible>
        );
    }
}
